import { Icon } from '@if/mui'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { MetricDisplayMode } from '@src/types/MerchantStatistic'
import { DollarSign, Hash } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface ViewModeToggleProps {
  value: MetricDisplayMode
  onChange: (mode: MetricDisplayMode) => void
}

export const ViewModeToggle = ({ value, onChange }: ViewModeToggleProps) => {
  const { t } = useTranslation()

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      size="small"
      onChange={(_, newMode: MetricDisplayMode | null) => newMode && onChange(newMode)}
    >
      <ToggleButton value={MetricDisplayMode.Count} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Icon icon={Hash} size="sm" />
        {t('merchantStatistics.merchantLoanActivity.viewCount')}
      </ToggleButton>
      <ToggleButton value={MetricDisplayMode.Amount} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Icon icon={DollarSign} size="sm" />
        {t('merchantStatistics.merchantLoanActivity.viewAmount')}
      </ToggleButton>
    </ToggleButtonGroup>
  )
}
